import gql from 'graphql-tag';
import { WorkflowFragment } from '../fragments/workflow.fragment';
import { TransactionFragment } from '../fragments/transaction.fragment';
import { KioskFragment } from '../fragments/kiosk.fragment';
import { GameAccountFragment } from '../fragments/game-account.fragment';

export const GET_DEPOSIT_WORKFLOW = gql`
  query($id: ID!) {
    workflow(id: $id) {
      ...WorkflowInfo
      amount
      toGameAccount {
        ...GameAccountInfo
      }
      fromGameAccount {
        ...GameAccountInfo
      }
      player {
        id
        serialNo
        name
        username
        phoneNo
      }
      paymentType {
        id
        name
      }
      playerBankAccount {
        id
        accountName
        accountNo
        bank {
          id
          name
        }
      }
      companyBankAccount {
        id
        accountName
        accountNo
        bank {
          id
          name
        }
      }
      bonus {
        id
        name
      }
      paymentGateway {
        id
        name
      }
      transactions {
        edges {
          node {
            ...TransactionInfo
            supersededById
            stepNumber
            retryAttempts
            player {
              upline {
                id
                username
              }
              id
              serialNo
              username
              name
              phoneNo
              telegramId
              lastDepositAmount
              lastDepositAt
              tags(sorting: { field: tagType, direction: ASC }) {
                edges {
                  node {
                    name
                    tagType
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${WorkflowFragment}
  ${TransactionFragment}
  ${GameAccountFragment}
`;
